// extracted by mini-css-extract-plugin
export default {"shell":"AppShell_shell__udZ-C","page":"AppShell_page__aq4Nw","sectionHidden":"AppShell_sectionHidden__GtYZm","sectionActive":"AppShell_sectionActive__hCGWf"};